import React from 'react';
import LazyPageLoader from './cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./Dashboard'))

export default function CustomPageLazy(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page {...props} />
    </React.Suspense>
}


